export default "__VITE_ASSET__oyFbDt0s__"